<script lang="ts">
  import dayjs from 'dayjs'
  import WalletAmount from '@/components/appDriver/wallet/WalletAmount.svelte'
  import type { WalletTransaction } from '@/components/appDriver/wallet/types'

  export let transaction: WalletTransaction

  $: isCredit = transaction.direction === 'credit'
  $: bookingId = transaction.bookingId?.trim()
  $: shouldShowBookingId = !!bookingId && bookingId.toUpperCase() !== 'N/A'
</script>

<article class="rounded-lg bg-white p-4 shadow">
  <div class="flex items-center justify-between gap-3 border-b border-gray-200 pb-3 text-xs uppercase text-gray-500">
    <div class="truncate">ລະຫັດ: {transaction.id}</div>
    {#if shouldShowBookingId}
      <div class="shrink-0">ເລກຖ້ຽວ: {bookingId}</div>
    {/if}
  </div>

  <div class="flex items-center gap-3 pt-4">
    <div class="{isCredit ? 'bg-green-500' : 'bg-red-500'} flex h-6 w-6 shrink-0 items-center justify-center rounded text-white">
      {#if isCredit}
        <svg viewBox="0 0 20 20" class="h-4 w-4" aria-hidden="true">
          <path fill="currentColor" d="M9 3h2v9l3.5-3.5 1.4 1.4L10 15.8 4.1 9.9l1.4-1.4L9 12V3Z" />
        </svg>
      {:else}
        <svg viewBox="0 0 20 20" class="h-4 w-4" aria-hidden="true">
          <path fill="currentColor" d="M9 17h2V8l3.5 3.5 1.4-1.4L10 4.2 4.1 10.1l1.4 1.4L9 8v9Z" />
        </svg>
      {/if}
    </div>

    <div class="min-w-0 flex-1">
      <div class="transaction-description text-sm font-semibold leading-5 text-blue-dark">{transaction.title}</div>
      <div class="text-sm text-gray-400">{dayjs(transaction.createdAt).format('YYYY-MM-DD HH:mm')}</div>
    </div>

    <div class="shrink-0 text-right text-lg font-bold {isCredit ? 'text-green-600' : 'text-red-500'}">
      <WalletAmount amount={transaction.amount}/>
    </div>
  </div>
</article>

<style>
  .transaction-description {
    display: -webkit-box;
    overflow: hidden;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }
</style>
